const ProfilePage = () => {
  return (
    <div>
      <h2>Profile</h2>
      <p>This is the profile page content.</p>
    </div>
  );
};

export default ProfilePage;
